var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"verification-code-btn",class:{'disabled': _vm.running},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.running ? ("已发送（" + _vm.cur + "）") : '获取验证码')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }